import { UserRole } from "../constants/roles.enum"
import { useAppSelector } from "./useRedux"

export const isAdmin = (roles: string[] = []) => {
    return roles.includes(UserRole.Admin)
}

export const useSession = () => {
    const session = useAppSelector((state) => state.session)

    const hasRole = (role?: string): boolean => {
        if (!role) {
            return true
        }

        return session.data?.roles?.includes(role) ?? false
    }

    return {
        hasRole,
        data: session.data,
        userId: session.data?.userId,
    }
}
